import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const InfoOutlineIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 14 15"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <g clipPath="url(#info-outline-icon_svg__a)">
            <path d="M6.3 4h1.4v1.4H6.3V4Zm0 2.8h1.4V11H6.3V6.8ZM7 .5c-3.864 0-7 3.136-7 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7Zm0 12.6a5.607 5.607 0 0 1-5.6-5.6c0-3.087 2.513-5.6 5.6-5.6 3.087 0 5.6 2.513 5.6 5.6 0 3.087-2.513 5.6-5.6 5.6Z"/>
        </g>
        <defs>
            <clipPath id="info-outline-icon_svg__a">
                <path transform="translate(0 .5)" d="M0 0h14v14H0z"/>
            </clipPath>
        </defs>
    </svg>
);
InfoOutlineIcon.displayName = 'InfoOutlineIcon';
export default InfoOutlineIcon;
